import { collectRef } from '@redneckz/json-ref';
import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { fetchRefs } from './fetchRefs.js';
import { resolveBlockProps } from './resolveBlockProps.js';
export const useJSONRef = (content, fallback) => {
    const refs = collectRef(content);
    const [refsMap, setRefsMap] = useState({});
    useEffect(() => {
        if (refs.length) {
            fetchRefs(refs).then(setRefsMap);
        }
    }, [refs.join()]);
    return refs.length ? resolveBlockProps(content, { ...fallback, ...refsMap }) : content;
};
//# sourceMappingURL=useJSONRef.js.map